module.exports = __webpack_public_path__ + "static/media/dtgl.30c67495.png";


//////////////////
// WEBPACK FOOTER
// ./src/img/dtgl.png
// module id = 1748
// module chunks = 0 1